import { Component, input } from '@angular/core';

export type PillButtonVariant =
  | 'primary'
  | 'gold'
  | 'ghost'
  | 'dark'
  | 'outline'
  | 'event-access';

@Component({
  selector: 'app-pill-button',
  standalone: true,
  templateUrl: './pill-button.component.html',
  styleUrl: './pill-button.component.scss',
})
export class PillButtonComponent {
  readonly label = input.required<string>();
  readonly href = input<string>('#');
  readonly variant = input<PillButtonVariant>('primary');
  readonly external = input(false);
}
